import {Pipe, PipeTransform, ChangeDetectorRef} from '@angular/core';
import {Router} from '@angular/router';
import {AlloxCommonAsyncPipe, IAlloxAsyncPipeFetch, IAlloxAsyncPipeOption} from './allox-common-async.pipe';
import {Deal, DealService} from '@app/core';

interface IDealPipeOption extends IAlloxAsyncPipeOption {
  name?: boolean;
}

@Pipe({
    name: 'deal', pure: false,
    standalone: false
})
export class DealPipe
  extends AlloxCommonAsyncPipe<Deal>
  implements IAlloxAsyncPipeFetch<Deal>, PipeTransform {

  constructor(private service: DealService, changeDetectorRef: ChangeDetectorRef, router: Router) {
    super(changeDetectorRef, router);
  }
  fetchDependency(value: number) {
    return this.service.fetch(value);
  }

  makeText(value: number, obj: Deal, option?: IDealPipeOption) {
    if (!obj) {
      return `Unknown [id: ${value}]`;
    }
    return obj.name;
  }
}
